import React, { createContext, useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

// Tipi per il Toast
type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastMessage {
  id: number;
  type: ToastType;
  message: string;
}

interface ToastContextProps {
  showToast: (message: string, type: ToastType) => void;
}

// Contesto per i Toast
const ToastContext = createContext<ToastContextProps | undefined>(undefined);

// Provider per i Toast
export const ToastProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  // Aggiungi un nuovo toast
  const showToast = (message: string, type: ToastType) => {
    const id = Date.now();
    setToasts((prevToasts) => [...prevToasts, { id, type, message }]);

    // Rimuovi automaticamente il toast dopo 5 secondi
    setTimeout(() => {
      setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, 5000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer position="top-end" className="p-3">
        {toasts.map((toast) => (
          <Toast key={toast.id} bg={toast.type}>
            <Toast.Header>
            <span className="me-auto">
                {toast.type === 'success' && <i className="bi bi-check-circle-fill text-success"></i>}
                {toast.type === 'error' && <i className="bi bi-x-circle-fill text-danger"></i>}
                {toast.type === 'info' && <i className="bi bi-info-circle-fill text-info"></i>}
                {toast.type === 'warning' && <i className="bi bi-exclamation-circle-fill text-warning"></i>}
            </span>
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
};

// Hook per utilizzare il contesto
export const useToast = (): ToastContextProps => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast deve essere usato all’interno di un ToastProvider');
  }
  return context;
};